import {
  Alert,
  Autocomplete,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

const title = 'Namespace';

export const RedshiftServerlessNamespaceSelect = ({
  accountId,
  regionName,
  namespaceName,
  onChange,
}: {
  accountId?: string;
  regionName?: string;
  namespaceName?: string;
  onChange: (namespaceName: string) => void;
}) => {
  if (!accountId || !regionName) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerNamespaceSelect
      accountId={accountId}
      regionName={regionName}
      namespaceName={namespaceName}
      onChange={onChange}
    />
  );
};

const InnerNamespaceSelect = ({
  accountId,
  regionName,
  namespaceName,
  onChange,
}: {
  accountId: string;
  regionName: string;
  namespaceName?: string;
  onChange: (namespaceName: string) => void;
}) => {
  const dal = useDAL();
  const { data: body, isLoading } =
    dal.restore.redshiftServerlessNamespaces.useList(accountId, regionName);

  const availableNamespaces =
    body?.namespaces?.filter((ns) => ns.status === 'AVAILABLE') ?? [];

  if (!isLoading && !availableNamespaces.length) {
    return (
      <FormControl size='small' className='flex-1'>
        <FormLabel>{title}</FormLabel>
        <Alert severity='warning' className='mt-[4px]'>
          <Typography variant='body2'>
            No available Redshift Serverless namespaces found in this region.
          </Typography>
        </Alert>
      </FormControl>
    );
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        data-testid='redshiftServerlessNamespaceSelect'
        clearOnBlur
        size='small'
        loading={isLoading}
        value={
          availableNamespaces.find(
            (ns) => ns.namespaceName === namespaceName
          ) || null
        }
        onChange={(_event, newValue) => onChange(newValue?.namespaceName || '')}
        getOptionLabel={(option) => option.namespaceName}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder='Select namespace'
            label=''
            slotProps={{ inputLabel: { shrink: true } }}
          />
        )}
        options={availableNamespaces}
      />
    </FormControl>
  );
};
